module.exports = {
  language: {
    name: "English"
  },
  //导航栏
  header: {
    home: "首页",
    product: "产品",
    company: "公司概况",
    contactUs: "联系我们",
    companyDynamics: "公司动态",
    auxiliaries: "纺织助剂",
    cuttingFluid: "金属切削液助剂",
    agricultural: "农业化学助剂",
    paint: "油漆和涂料助剂"
  },
  //首頁
  home: {
    companyName: "南京尚勤新材料科技有限公司",
    aboutUs: '关于我们',
    companyProfile1: `尚勤（Skyline Chemical）是国内领先的化学品制造企业，国家高新技术企业，坐落于六朝古都南京。`,
    companyProfile2: `十余年来，公司持续深耕特种化学品领域，组建了专业高效的研发团队，并与多家世界500强化工企业建立了深入合作关系，成功开发近100种特殊结构化学品，
    凭借稳定品质与创新能力赢得了全球客户的信赖与行业高度认可， 产品远销欧美和东南亚等诸多全球化工50强客户。
    2025年，公司位于国家级化工园---南京江北新材料科技园的生产基地正式建成投产，精良且规范的设施配备、充足的生产能力为规模化、高品质交付提供坚实保障。`,
    companyProfile3: `公司专注于磷酸酯、TMPTO、特种反应单体等各类酯化产品及特殊聚合物的研发、生产与销售，产品广泛应用于纺织皮革助剂、润滑油及金属加工液（MWF）、农药制剂、油漆涂料、家居与工业清洁（HI&I）、半导体、新能源等多个领域。
尚勤始终以客户为中心，视客户为长期可靠的战略伙伴。我们不仅提供标准化优质产品，更具备强大的定制化开发与解决方案服务能力，愿与各界伙伴携手共进，共创价值、共赢未来。`,
    chemicalExperts: '您身边的化工专家',
    advisoryService: '全天提供出色的咨询服务',
    productCatalog: '产品目录',
    teamPresentation: '团队展示',
    companyCertificate: '公司证书',
    recentProjects: '我们最近的项目',
    productClassification: '产品分类',
    makeUp: '组成',
    seeMore: '查看更多',
    navigationBar: '导航栏',
    subcategory: '所属分类',
    keyword: '关键词',
    productConsulting: '产品咨询',
    productDescription: '产品描述',
    applicationAndPerformance: '用途及性能',
    applicationField: '应用领域'
  },

  // 公司简介
  company: {
    companyProfile: "公司简介",
    excellentQuality: "卓越的品质",
    excellentQualitySub: "高品质的、先进的、专业的",
    excellentQualityContent: "根据需求，我们支持量身定制的产品，并确保最好的质量。",
    supportOEM: "支持OEM和ODM定制",
    supportOEMSub: "广泛应用、生产经验、多通道、专业团队、支持定制",
    supportOEMCosntent: "不仅仅是产品，还有相应的解决方案！专注于特种化学品！",
    since2010: "自2010年以来",
    since2010Sub: "多年的生产经验",
    since2010Content: "公司成立于2010年，是一家集研发、生产、销售、服务为一体的专用化学品公司，于2020年被评为国家级高新技术企业。",
    tailorMade: "特制的",
    tailorMadeSub: "欢迎定制特殊产品",
    tailorMadeContent: "更重要的是，我们能够提供高品质的定制专业除了常规产品。",
  },


  //联系我们
  contactUs: {
    company: "公司",
    name: "姓名",
    email: "邮箱",
    tel: "电话",
    content: "内容",
    inputCompany: "请输入公司",
    inputName: "请输入姓名",
    inputEmail: "请输入邮箱",
    inputTel: "请输入电话",
    inputContent: "请输入内容",
    submit: "提交",
    address: "南京市栖霞区仙林街道纬地路9号29号楼517室",
    address1: "地址：南京市栖霞区仙林街道纬地路9号29号楼517室"
  }

}



// WEBPACK FOOTER //
// ./src/utils/language/zh.js